function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@domain-group/fe-co-loader';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import UserInput from './user-input';
import Footer from './footer';
import * as styles from './reset-password.style';
import * as commonStyles from '../../style/common.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class ResetPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getFieldValue", key => this.state.signInFields[key].value);
    _defineProperty(this, "getData", () => ({
      password: this.getFieldValue('password').trim()
    }));
    _defineProperty(this, "submitForm", () => {
      if (!this.validate()) {
        return;
      }
      this.setState({
        isSubmitting: true
      });
      var _this$getData = this.getData(),
        password = _this$getData.password;
      this.props.onSaveClick(password, {
        id: this.props.username,
        token: this.props.token
      }).finally(() => {
        this.setState({
          isSubmitting: false
        });
      });
    });
    _defineProperty(this, "validateField", (key, value) => {
      var field = this.signInFields[key];
      var error;
      if (field.required && !value) {
        error = field.requiredErrorMessage;
      } else if (field.validate) {
        error = field.validate(value);
      }
      return {
        value,
        error: error || ''
      };
    });
    _defineProperty(this, "validate", () => {
      var newState = this.allFields.reduce((state, key) => _objectSpread(_objectSpread({}, state), {}, {
        [key]: this.validateField(key, this.state.signInFields[key].value.trim())
      }), {});
      this.setState({
        signInFields: newState
      });
      return Object.values(newState).every(_ref => {
        var error = _ref.error;
        return !error;
      });
    });
    _defineProperty(this, "handleFieldChange", (key, value) => {
      var fieldState = {
        value,
        error: ''
      };
      this.setState(prevState => ({
        signInFields: _objectSpread(_objectSpread({}, prevState.signInFields), {}, {
          [key]: fieldState
        })
      }));
    });
    _defineProperty(this, "renderField", (key, type) => {
      var field = this.signInFields[key];
      var fieldState = this.state.signInFields[key];
      return ___EmotionJSX(UserInput, _extends({
        iconName: field.icon,
        fieldType: type,
        fieldName: key,
        placeHolder: field.label,
        onValueChange: event => {
          this.handleFieldChange(key, event.target.value);
        }
      }, field.canSubmit ? {
        onSubmit: this.submitForm
      } : {}, {
        fieldError: fieldState.error,
        fieldValue: fieldState.value,
        focus: field.focus || false
      }));
    });
    this.signInFields = {
      password: {
        label: 'Password',
        icon: 'lock',
        required: true,
        requiredErrorMessage: 'Please enter your new password',
        focus: true,
        canSubmit: true
      }
    };
    this.allFields = Object.keys(this.signInFields);
    this.state = {
      isSubmitting: false,
      signInFields: {
        password: {
          value: '',
          error: ''
        }
      }
    };
  }
  componentDidMount() {
    setTimeout(() => {
      document.getElementsByName('password')[0].focus();
    }, 1);
  }
  render() {
    var error = this.props.error;
    return ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: styles.title
    }, "Reset my password"), ___EmotionJSX("div", {
      css: styles.formSubmitMessage
    }, "What would you like your new password to be?"), error.length > 0 && ___EmotionJSX("div", {
      css: commonStyles.formSubmitError
    }, error[0].message || 'Failed to submit request. Please try again later.'), ___EmotionJSX("form", {
      method: "dialog",
      onSubmit: event => {
        event.preventDefault();
        return false;
      }
    }, this.renderField('password', 'password'), ___EmotionJSX(Button, {
      css: commonStyles.submitButton,
      onClick: this.submitForm,
      disabled: this.state.isSubmitting
    }, this.state.isSubmitting ? ___EmotionJSX(Loader, {
      css: commonStyles.submitButtonLoader,
      dark: true,
      transparent: true,
      size: "mini"
    }) : 'Save & log in')), ___EmotionJSX(Footer, {
      onCloseModal: this.props.onCloseModalCallback
    }));
  }
}
ResetPasswordPage.propTypes = {
  username: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  error: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string
  })),
  onSaveClick: PropTypes.func,
  onCloseModalCallback: PropTypes.func.isRequired
};
ResetPasswordPage.defaultProps = {
  error: [],
  onSaveClick: () => Promise.resolve()
};
export default ResetPasswordPage;